module.exports = __webpack_public_path__ + "img/add-photo.2d17860b.svg";